import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue';
import { I18nMessages } from '../../../../i18n/messages';
import { MazeedModule } from '../../../store/module';
import AppStoreReadyStateEnum from '../../../../app/store/ready-state.enum';


export default /*#__PURE__*/_defineComponent({
  __name: 'FastActivationSidebarBadge',
  setup(__props) {

const isMazeedNotActivated = computed((): boolean => {
  return (
    MazeedModule.storeSummaryLoadingState !== AppStoreReadyStateEnum.loading &&
    MazeedModule.storeSummary?.status !== 'active'
  );
});

onMounted(() => {
  if (!MazeedModule.storeSummary) MazeedModule.getStoreSummary();
});

return { __sfc: true,isMazeedNotActivated, I18nMessages }
}

})